import styled from "styled-components";
import { dimensions } from "../../constants";
import { colors } from "../../styles";

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 10px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colors.defaultHeader};

  @media (max-width: ${dimensions.mobile}px) {
    flex-direction: column;
  }
`;

export const Flags = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 0;
  padding: 10px;

  @media (max-width: ${dimensions.mobile}px) {
    position: relative;
  }
`;

export const Flag = styled.img`
  height: 25px;
  cursor: pointer;
  margin-right: 6px;

  &:last-child {
    margin-right: 0;
  }
`;
